import memo from "fast-memoize";
import fetch from "./fetch-trade-api";

const accountSettings = async ({ accountId }) => {
  const resp = await fetch(`/v1/report/settings/account/${accountId}`);
  return resp.json();
};

export default memo(accountSettings, {
  serializer: ({ accountId }) => accountId
});
